module.exports = __webpack_public_path__ + "static/hyperv_31.8a3e1982.jpg";